import Api from './apiCall';
import {API_URLS} from '../constant/index';

export const getFoundationPageService = async params => {
      const result = await Api.get(API_URLS.GET_FOUNDATION_PAGE_URL, params);
      return result;
  };

